import api from './axios';

export type UserRole = 'parent' | 'staff' | 'admin';

export interface User {
  id: number;
  email: string;
  role: UserRole;
  firstName: string;
  lastName: string;
  phone?: string;
  createdAt: string;
  updatedAt: string;
}

export interface RegisterPayload {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role?: UserRole;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface AuthResponse {
  user: User;
  accessToken: string;
  refreshToken: string;
}

export interface RefreshPayload {
  refreshToken: string;
}

export const register = async (payload: RegisterPayload): Promise<AuthResponse> => {
  console.debug('[auth-api] Registering user', { email: payload.email });
  const { data } = await api.post<AuthResponse>('/api/auth/register', payload);
  console.debug('[auth-api] Registration success', { id: data.user.id });
  return data;
};

export const login = async (payload: LoginPayload): Promise<AuthResponse> => {
  console.debug('[auth-api] Logging in user', { email: payload.email });
  const { data } = await api.post<AuthResponse>('/api/auth/login', payload);
  console.debug('[auth-api] Login success', { id: data.user.id, role: data.user.role });
  return data;
};

export const refresh = async (payload: RefreshPayload): Promise<AuthResponse> => {
  console.debug('[auth-api] Refreshing token');
  const { data } = await api.post<AuthResponse>('/api/auth/refresh', payload);
  console.debug('[auth-api] Token refresh success', { id: data.user.id });
  return data;
};

export const logout = async (accessToken: string): Promise<void> => {
  console.debug('[auth-api] Logging out user');
  await api.post(
    '/api/auth/logout',
    {},
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  console.debug('[auth-api] Logout success');
};

export const getCurrentUser = async (accessToken: string): Promise<User> => {
  console.debug('[auth-api] Fetching current user');
  const { data } = await api.get<User>('/api/auth/me', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  console.debug('[auth-api] Current user fetched', { id: data.id });
  return data;
};
